import request from "@/util/http";
import qs from "qs"; // 获取个人信息

export var getPersonalInfo = function getPersonalInfo() {
  return request({
    url: "/admin/personalCenter/info",
    method: "get"
  });
}; // 获取用户登录数据

export var getLogData = function getLogData(params) {
  return request({
    url: "/admin/log/page",
    method: "get",
    params: params
  });
}; // 修改个人信息

export var updatePersonInfo = function updatePersonInfo(data, userId) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/personalCenter/edit/".concat(userId),
    method: "post",
    data: data
  });
}; // 修改密码

export var passwordEdit = function passwordEdit(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/personalCenter/changePassword",
    method: "post",
    data: JSON.stringify(data)
  });
};